package ui.components

import SidebarItem
import api.data.response.DataAdminProfile
import dataAdminProfile
import emotion.react.css
import getAdminData
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.ReactNode
import react.createElement
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import react.router.useNavigate
import react.useState
import routes.EnumRoutes
import web.cssom.ClassName
import web.cssom.Position
import web.cssom.vh

external interface NavBarProps: Props{
    var activeNavItem: String
    var sidebarItemsList: ArrayList<DataSidebarMenu>
//    var adminData: DataAdminProfile


}

data class DataSidebarMenu(
    val icon: ReactNode,
    val label: String,
    val to: String,
)
val NavBar = FC<NavBarProps> {
    val activeNavItem by useState(it.activeNavItem)
    val sidebarItemsList by useState(arrayListOf(
        DataSidebarMenu(
            icon = createElement(DashboardIcon),
            label = "Dashboard",
            to = EnumRoutes.Dashboard.routeID,

            ),
        DataSidebarMenu(
            icon = createElement(ListingsIcon),
            label = "Properties",
            to = EnumRoutes.Properties.routeID
        ),
        DataSidebarMenu(
            icon = createElement(OwnerSubmissionsIcon),
            label = "Owner Submissions",
            to = EnumRoutes.OwnerSubmissions.routeID
        ),
        DataSidebarMenu(
            icon = createElement(InquiriesIcon),
            label = "Inquiries",
            to = EnumRoutes.PropertyInquiries.routeID),
        DataSidebarMenu(
            icon = createElement(ScheduleIcon),
            label = "Visit Scheduler",
            to = EnumRoutes.ScheduledVisit.routeID
        )))
    var isSidebarOpen by useState(false)
    var adminData by useState(dataAdminProfile)

    // Mobile Menu Button
    button {
        className = ClassName("lg:hidden fixed top-4 left-4 z-50 bg-boon-primary text-white p-2 rounded-lg")
        onClick = { isSidebarOpen = !isSidebarOpen }

        if (isSidebarOpen) {
            CloseIcon()
        } else {
            MenuIcon()
        }
    }

    // Sidebar
    div {
        css(ClassName(
            "fixed lg:static inset-y-0 left-0 z-40 w-80 bg-boon-bg-light flex flex-col " +
                    "transform ${if (isSidebarOpen) "translate-x-0" else "-translate-x-full"} " +
                    "lg:translate-x-0 transition-transform duration-300 ease-in-out"
        )) {

//            position = Position.sticky;
            height= 100.vh
        }

        // Logo
        div {
            className = ClassName("flex justify-center p-6 mt-12 lg:mt-0")
            img {
                src = "https://api.builder.io/api/v1/image/assets/TEMP/8476af9399157c36bdeb92434c79697dd7909f64"
                alt = "Boon Logo"
                className = ClassName("w-24 h-28")
            }
        }
        div {
            className = ClassName("flex-1 px-3 py-2")
            sidebarItemsList.forEach {sidebarItem->
                SidebarItem{
                    this.icon = sidebarItem.icon
                    this.label = sidebarItem.label
                    this.isActive = (activeNavItem == sidebarItem.label)
                    this.to = sidebarItem.to
                }
            }

        }
        // User Profile
        div {
            className = ClassName("p-6 flex items-center gap-4 cursor-pointer hover:bg-gray-100 rounded-lg transition-colors")
            img {
                src = "https://api.builder.io/api/v1/image/assets/TEMP/9caaab8a0eb422daf0198888257bb273fdfdcab5"
                alt = "Admin User"
                className = ClassName("w-8 h-8 rounded-full")
            }
            div {
                div {
                    className = ClassName("text-sm font-normal text-black")
                    + "${adminData.firstName} ${adminData.lastName}"
                }
                div {
                    className = ClassName("text-sm font-normal text-boon-gray")
                    +"Administrator"
                }
            }
            onClick = {
                window.location.href = EnumRoutes.AdminProfile.routeID
            }
        }
    }

    // Overlay for mobile
    if (isSidebarOpen) {
        div {
            className = ClassName("lg:hidden fixed inset-0 z-30 bg-black bg-opacity-50")
            onClick = { isSidebarOpen = false }
        }
    }
}

